export const getPosition = el => {
  return { top: el.offsetTop, left: el.offsetLeft }
}
